import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faUserXmark } from '@fortawesome/pro-solid-svg-icons';
import UiVirtualScroll from '../../../../../../../../../components/VirtualScroll';
import StudentClipboardImg from '../../../../../../../../../assets/images/studentClipboard.png';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import FloatingMenu from '../../../../../../../../../components/floatingMenu/floatingMenu';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import TableSkeleton from '../../../../../../../../../components/SkeletonLoader/TableSkeleton';
import { useParams } from 'react-router';
import { ActivityUtils } from '../../../../../../../../activitySearch/activityUtils';
import ActivityTypes from '../../../../../../../../../enums/activityTypes';

const  NotAssignedTable = ({
  notAssignedStudents,
  setNotAssignedStudents,
  selectedClassFilterIds,
  dataStatus,
  refetchCallback,
  showAssignmentSettings,
  setShowAssignmentSettings,
  isLoading
}) => {
  const sortByAscending = useRef(true);
  const sortResultsBy = useRef('sort-lastName');
  const { activityType = ActivityTypes.Assignment } = useParams();

  const [floatingMenuButtons, setFloatingMenuButtons] = useState([
    {
      id: 1,
      name: `${ActivityUtils.getActivityName(activityType)} Settings`,
      tooltip: `${ActivityUtils.getActivityName(activityType)} Settings`,
      icon: <FontAwesomeIcon icon={faGear} />,
      disabled: false,
      isEnabled: showAssignmentSettings
    }
  ]);

  const handleClick = () => {
    updateSettings(!showAssignmentSettings);
    setShowAssignmentSettings(!showAssignmentSettings);
  };

  const updateSettings = (isEnabled) =>{
    let tempArray = [...floatingMenuButtons];
    tempArray[0].isEnabled = isEnabled;
    setFloatingMenuButtons(tempArray);
  };

  const handleAssignmentChecked = (e) => {
    const { name, checked } = e.target;
    let tempAssignmentResults = [];

    if (name === 'allselect') {
      tempAssignmentResults = notAssignedStudents.map((item) => {
        return { ...item, isChecked: checked };
      });
    } else {
      tempAssignmentResults = notAssignedStudents.map((item) =>
        item.studentId == name ? { ...item, isChecked: checked } : item
      );
    }
    setNotAssignedStudents(tempAssignmentResults);
  };

  const handleAssignmentSort = (e) => {
    let sortedAssignmentResults = [...notAssignedStudents];
    if (e) sortByAscending.current = !sortByAscending.current;
    switch (sortResultsBy.current) {
    case 'sort-lastName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
      break;
    case 'sort-firstName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentFirstName > b.studentFirstName ? 1 : -1
      );
      break;
    case 'sort-className':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.className > b.className ? 1 : -1
      );
      break;
    default:
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
    }
    if (!sortByAscending.current) sortedAssignmentResults.reverse();

    setNotAssignedStudents(sortedAssignmentResults);
  };

  return (
    <>
      <div className="custom-table table-responsive" style={{ width: '55%' }}>
        {!isLoading ? (
          <UiVirtualScroll rowHeight={60} height="400px">
            <table className="table">
              <thead>
                <tr>
                  <th>
                    {notAssignedStudents?.length > 0 &&
                      <input
                        type="checkbox"
                        className="form-check-input"
                        value=""
                        id="flexCheckDefault"
                        name="allselect"
                        checked={
                          notAssignedStudents?.filter(
                            (item) =>
                              item?.isChecked !== true
                          ).length < 1
                        }
                        onChange={handleAssignmentChecked}
                        defaultChecked={false}
                      />
                    }
                  </th>
                  <th>
           Last Name
                    <button
                      className="sort-btn"
                      id="sort-lastName"
                      onClick={(e) => {
                        sortResultsBy.current = e.target.id;
                        handleAssignmentSort(e);
                      }}>
                      <FontAwesomeIcon icon={faSort} />
                    </button>
                  </th>
                  <th>
           First Name
                    <button
                      className="sort-btn"
                      id="sort-firstName"
                      onClick={(e) => {
                        sortResultsBy.current = e.target.id;
                        handleAssignmentSort(e);
                      }}>
                      <FontAwesomeIcon icon={faSort} />
                    </button>
                  </th>
                  <th>
           Class
                    <button
                      className="sort-btn"
                      id="sort-className"
                      onClick={(e) => {
                        sortResultsBy.current = e.target.id;
                        handleAssignmentSort(e);
                      }}>
                      <FontAwesomeIcon icon={faSort} />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataStatus.isError && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>
                      <button
                        style={{
                          color: '#F84646',
                          fontSize: '1.15rem',
                          border: 'none',
                          background: 'none'
                        }}
                        onClick={() => refetchCallback()}>
               There was an error getting the data. Click to try again
                      </button>
                    </td>
                  </tr>
                )}

                {!isLoading &&
       (notAssignedStudents.length == 0) && (
                  <tr>
                    <td colSpan="4">
                      <div
                        className="d-flex align-items-end justify-content-center text-align-center"
                        style={{
                          backgroundImage: `url(${StudentClipboardImg})`,
                          backgroundRepeat: 'no-repeat',
                          height: '130px',
                          backgroundPositionX: 'center'
                        }}>
                        {dataStatus?.data?.totalAssignedStudents == 0 ? (
                          <span>There are no students available for this assignment</span>
                        ) : (
                          <span>{`There are no available students within the selected class${
                            selectedClassFilterIds.length === 1 ? '' : 'es'
                          }`}</span>
                        )}
                      </div>
                    </td>
                  </tr>
                )}

                {notAssignedStudents &&
         notAssignedStudents.map((item, index) => {
           let bestScore = 0;
           if (item.retakeResults) {
             let retakes = [...item.retakeResults];
             retakes
               .sort(
                 (a, b) =>
                   a.retriesAsNoCreditScore?.percent - b.retriesAsNoCreditScore?.percent
               )
               .reverse();
             bestScore = retakes[0]?.retriesAsNoCreditScore;
             if (item.retriesAsNoCreditScore?.percent > bestScore?.percent)
               bestScore = item.retriesAsNoCreditScore;
           }

           return (
             <tr key={`notAssignedStudentRow_${index}`}>
               <td>
                 {item.isDeactivated ? (
                   <div className="deactivatedUserIcon">
                     <div className="d-flex flex-row"></div>
                     <OverlayTrigger
                       key="deactivated"
                       placement="right"
                       overlay={
                         <Tooltip id="tooltip-deactivated" className="tooltip-white">
                           <h4>Deactivated</h4>
                           <p className="mb-0">
                             Students cannot use deactivated accounts, but teacher and
                             administrator reports do include data for these accounts{' '}
                           </p>
                         </Tooltip>
                       }>
                       <div className="deactivated">
                         <FontAwesomeIcon icon={faUserXmark} />
                       </div>
                     </OverlayTrigger>
                   </div>
                 ) : (
                   <input
                     type="checkbox"
                     value=""
                     name={item.studentId}
                     checked={item?.isChecked || false}
                     onChange={handleAssignmentChecked}
                     className="form-check-input"
                     id={`flexCheckDefault${index}`}
                   />
                 )}
               </td>
               <td>{item.studentLastName}</td>
               <td>{item.studentFirstName}</td>
               <td>{item.className}</td>
             </tr>
           );
         })}
              </tbody>
            </table>
          </UiVirtualScroll>   
        ):(
          <>
            {isLoading && (
              <TableSkeleton
                rowCount={4}
                colCount={3}
                skeletonClass='p-1'
              />
            )}
          </>
        )}
      </div>
      <div className="d-flex floating-menu-contained floating-menu-sticky justify-content-center">
        <FloatingMenu floatingButtons={floatingMenuButtons} onClick={handleClick}/>
      </div>
    </>
  );
};

NotAssignedTable.propTypes = {
  notAssignedStudents: PropTypes.array.isRequired,
  setNotAssignedStudents: PropTypes.object,
  selectedClassFilterIds: PropTypes.array,
  refetchCallback: PropTypes.function,
  dataStatus: PropTypes.object,
  showAssignmentSettings:PropTypes.bool,
  setShowAssignmentSettings: PropTypes.func,
  isLoading:PropTypes.bool
};

export default NotAssignedTable;
